// extracted by mini-css-extract-plugin
module.exports = {"mixed":"style_mixed__1jfGo"};